module.exports = __webpack_public_path__ + "img/configuration.4f499bc3.png";